<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                Agregar Grupo de Aplicación
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="70%"
          >
            <p>
              A continuación encontrarás toda la información asociada al
              registro seleccionado.
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6><strong>Nombre de Grupo:</strong></h6>
                        {{ rowData.group_name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6><strong>[Peso Mín. - Peso Máx.]:</strong></h6>
                        <span
                          >[{{ rowData.lower_weight }} -
                          {{ rowData.upper_weight }}]</span
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6><strong>Cultivo:</strong></h6>
                        <span v-if="rowData.crop">{{ rowData.crop.name }}</span>
                        <span v-else>TODOS</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6><strong>Zona de abastecimiento:</strong></h6>
                        <span v-if="rowData.zone">{{ rowData.zone.name }}</span>
                        <span v-else>TODAS</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6><strong>Zona geográfica:</strong></h6>
                        <span v-if="rowData.subzone">{{
                          rowData.subzone.name
                        }}</span>
                        <span v-else>TODAS</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6><strong>Variedad:</strong></h6>
                        <span v-if="rowData.crop_variety">{{
                          rowData.crop_variety.name
                        }}</span>
                        <span v-else>TODAS</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-muted">
                  <small>Creado el: {{ rowData.created_at }}</small>
                </p>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              placeholder="Por página"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              placeholder="Buscar registros"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              style="width: 100%"
              :data="queriedData"
              border
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                label="Operaciones"
                fixed="right"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="'Ver'"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="'Editar'"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="'Borrar'"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            Usted no tiene permisos para indexar la información registrada en el
            sistema
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Mostrando {{ from + 1 }} a {{ to }} de {{ total }} entradas
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              Exportar a PDF
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              Exportar a Excel
            </button>
          </div>
        </div>
      </div>
      <div>
        <el-dialog
          v-if="isCreate()"
          :title="title"
          :visible.sync="modals.create"
          width="70%"
        >
          <form>
            <p class="cm-mg-p-wzd">
              1.1 A continuación llena los siguientes campos, con los datos
              generales de el grupo.
            </p>
            <hr />
            <br />
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group has-label">
                  <label class="text-transform-none"
                    >Seleccionar una o varias empresas *</label
                  >
                  <br />
                  <el-select
                    clearable
                    class="select-primary custom-width-select bus-rels shadow-sm"
                    size="large"
                    v-model="applicationGroupForm.businesses_id"
                    placeholder="Seleccionar..."
                    filterable
                    multiple
                    collapse-tags
                    @change="
                      getZones();
                      selectAllFromSelect(
                        'applicationGroupForm.businesses_id',
                        businesses
                      );
                    "
                  >
                    <el-option
                      v-for="option in businesses"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="option.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <fg-input
                  ref="group_name"
                  type="text"
                  label="Nombre de Grupo *"
                  v-model="applicationGroupForm.group_name"
                  v-validate="modelValidations.group_name"
                  name="nombre de grupo"
                  :error="getError('nombre de grupo')"
                >
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group has-label">
                  <label class="text-transform-none width-label"
                    >Seleccione un cultivo *</label
                  >
                  <br />
                  <el-select
                    clearable
                    class="select-primary custom-width-select crop-rels shadow-sm"
                    size="large"
                    v-model="applicationGroupForm.crop_id"
                    placeholder="Seleccionar..."
                    filterable
                    @change="getCropVarieties"
                  >
                    <el-option
                      v-for="option in crops"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group has-label">
                  <label class="text-transform-none"
                    >Seleccione una zona de abastecimiento *</label
                  >
                  <br />
                  <el-select
                    clearable
                    class="select-primary custom-width-select zone-rels shadow-sm"
                    size="large"
                    v-model="applicationGroupForm.zone_id"
                    placeholder="Seleccionar..."
                    filterable
                    @change="getSubzones"
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      label="TODAS"
                    ></el-option>
                    <el-option
                      v-for="option in zones"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group has-label">
                  <label class="text-transform-none width-label"
                    >Seleccione una zona geográfica *</label
                  >
                  <br />
                  <el-select
                    clearable
                    class="select-primary custom-width-select subzone-rels shadow-sm"
                    size="large"
                    v-model="applicationGroupForm.subzone_id"
                    placeholder="Seleccionar..."
                    filterable
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      label="TODAS"
                    ></el-option>
                    <el-option
                      v-for="option in subzones"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group has-label">
                  <label class="text-transform-none width-label"
                    >Seleccione una variedad *</label
                  >
                  <br />
                  <el-select
                    clearable
                    class="select-primary custom-width-select cropvariety-rels shadow-sm"
                    size="large"
                    v-model="applicationGroupForm.crop_variety_id"
                    placeholder="Seleccionar..."
                    filterable
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      label="TODAS"
                    ></el-option>
                    <el-option
                      v-for="option in crop_varieties"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <p class="cm-mg-p-wzd">
              1.2 Digita la información del rango de pesos.
            </p>
            <hr />
            <br />
            <div class="row">
              <div class="col-12 col-md-6 col-xl-4">
                <fg-input
                  ref="lower_weight"
                  type="text"
                  label="Peso Mín. *"
                  v-model="applicationGroupForm.lower_weight"
                  v-validate="modelValidations.lower_weight"
                  name="Peso Mínimo"
                  :error="getError('Peso Mínimo')"
                >
                </fg-input>
              </div>
              <div class="col-12 col-md-6 col-xl-4">
                <fg-input
                  ref="upper_weight"
                  type="text"
                  label="Peso Máx. *"
                  v-model="applicationGroupForm.upper_weight"
                  v-validate="modelValidations.upper_weight"
                  name="Peso Máximo"
                  :error="getError('Peso Máximo')"
                >
                </fg-input>
              </div>
            </div>
            <div class="row" v-show="errorAlert">
              <div class="col-lg-12">
                <br />
                <el-alert ref="error_alert" title="Errores" type="error">{{
                  error
                }}</el-alert>
              </div>
            </div>
          </form>
          <span slot="footer" class="dialog-footer">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="closeModal('create')"
            >
              Cancelar</button
            >&nbsp;
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="validate"
            >
              Confirmar
            </button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import mixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import table from './applicationGroupTable';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  data() {
    return {
      applicationGroupForm: {
        group_name: null,
        lower_weight: null,
        upper_weight: null,
        crop_id: null,
        zone_id: null,
        subzone_id: null,
        crop_variety_id: null,
        businesses_id: [],
      },
      modelValidations: {
        group_name: {
          required: true,
        },
        lower_weight: {
          required: true,
        },
        upper_weight: {
          required: true,
        },
      },
      businesses: null,
      crops: [],
      zones: [],
      subzones: [],
      crop_varieties: [],
      tableColumns: table,
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    mixinDatePicker,
    MixinExport,
    MixinMenu,
  ],

  methods: {
    openModal(name) {
      if (name == 'create') {
        this.title = 'Agregar Grupo de Aplicación';
        this.$validator.reset();
        this.applicationGroupForm = {
          group_name: null,
          lower_weight: null,
          upper_weight: null,
          crop_id: null,
          zone_id: null,
          subzone_id: null,
          crop_variety_id: null,
          businesses_id: [],
        };
      }

      this.modals[name] = true;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.applicationGroupForm.businesses_id.length == 0) {
            this.highlightItem('nut-rels');
            return false;
          } else if (this.applicationGroupForm.crop_id == null) {
            this.highlightItem('crop-rels');
            return false;
          } else if (this.applicationGroupForm.zone_id == null) {
            this.highlightItem('zone-rels');
            return false;
          } else if (this.applicationGroupForm.subzone_id == null) {
            this.highlightItem('subzone-rels');
            return false;
          } else if (this.applicationGroupForm.crop_variety_id == null) {
            this.highlightItem('cropvariety-rels');
            return false;
          } else {
            this.addEditApplicationGroup();
          }
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = 'Editar Grupo: ' + row.group_name;
      this.applicationGroupForm = Object.assign({}, row);

      this.getZones();
      this.getSubzones();
      this.getCropVarieties();

      this.applicationGroupForm.route = 'fertilization/applicationgroups';

      if (row.zone_id == null) {
        this.applicationGroupForm.zone_id = 0;
      }

      if (row.subzone_id == null) {
        this.applicationGroupForm.subzone_id = 0;
      }

      if (row.crop_variety_id == null) {
        this.applicationGroupForm.crop_variety_id = 0;
      }

      this.errors.clear();
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.applicationGroupForm = row;
      SweetAlert.delete(row.group_name).then((result) => {
        if (result.value) this.deleteApplicationGroup();
      });
    },

    showMessageErrorsDivAlert(error) {
      this.showHideLoading();
      this.applicationGroupForm.route = null;

      let msg = `${i18n.t('common_words.ups')}<br/><br/>`;
      if (error.response && error.response.data && error.response.data.errors) {
        let i = 1;
        for (var key in error.response.data.errors) {
          msg += `${i++}. ${error.response.data.errors[key]} <br/>`;
        }
      } else {
        if (error.response) {
          if (error.response.data && error.response.data.message) {
            msg = error.response.data.message;
          } else {
            msg =
              'Error al enviar la información, por favor revise los datos suministrados.';
          }
        } else {
          msg =
            'Error al enviar la información, por favor revise los datos suministrados.';
        }
      }

      this.errorAlert = true;

      setTimeout(() => {
        this.$refs.error_alert.$el.children[0].children[1].innerHTML = msg;
      }, 10);

      setTimeout(() => {
        this.errorAlert = false;
        this.$refs.error_alert.$el.children[0].children[1].innerHTML = 'a';
      }, 15000);
    },

    addEditApplicationGroup() {
      this.showHideLoading(true);

      if (
        this.applicationGroupForm.route == 'fertilization/applicationgroups'
      ) {
        if (this.isUpdate()) {
          Axios.updateMaster(this.applicationGroupForm)
            .then((response) =>
              this.modifyTable(1, this.applicationGroupForm.id, response)
            )
            .catch((error) => this.showMessageErrorsDivAlert(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        this.applicationGroupForm.route = 'fertilization/applicationgroups';

        if (this.isCreate()) {
          Axios.saveMaster(this.applicationGroupForm)
            .then((response) =>
              this.modifyTable(0, this.applicationGroupForm.id, response)
            )
            .catch((error) => this.showMessageErrorsDivAlert(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    /**
     * el servicio de: zones/indexbussiness
     * se encuentra deshabilitado porque se hizo una refactorización de este
     * elemento. Me informan que este componente no está en uso, cuando se realice
     * la implementación (dado el caso) se tiene que modificar este método con
     * el servicio correspondiente.
     */
    getZones() {
      console.error('getZones disabled');
      /* if (this.applicationGroupForm.businesses_id.length > 0) {
        this.showHideLoading(true);
        let datarequest = {
          route: 'zones/indexbussiness',
          businesses_id: this.applicationGroupForm.businesses_id,
        };
        Axios.saveMaster(datarequest)
          .then((response) => {
            this.zones = response.data.data;
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.zones = [];
      } */
    },

    getCropVarieties() {
      if (
        this.applicationGroupForm.crop_id != null &&
        this.applicationGroupForm.crop_id != ''
      ) {
        this.showHideLoading(true);
        Axios.getMasters('cropvarieties/' + this.applicationGroupForm.crop_id)
          .then((response) => {
            this.crop_varieties = response.data.data;
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.crop_varieties = [];
      }
    },

    /**
     * el servicio de: subzones/indexzone/
     * se encuentra deshabilitado porque se hizo una refactorización de este
     * elemento. Me informan que este componente no está en uso, cuando se realice
     * la implementación (dado el caso) se tiene que modificar este método con
     * el servicio correspondiente.
     */
    getSubzones() {
      console.error('getSubzones disabled');
      /* if (this.applicationGroupForm.zone_id != null) {
        this.showHideLoading(true);
        Axios.getMasters(
          'subzones/indexzone/' + this.applicationGroupForm.zone_id
        )
          .then((response) => {
            this.subzones = response.data.data;
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.subzones = [];
      } */
    },

    deleteApplicationGroup() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.applicationGroupForm.route = 'fertilization/applicationgroups';
        Axios.destroyMaster(this.applicationGroupForm)
          .then((response) =>
            this.modifyTable(2, this.applicationGroupForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'fertilization/applicationgroups/pdf';
      data.name_file = `${i18n.t('fertilization.application_groups')}.pdf`;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'fertilization/applicationgroups/excel';
      data.name_file = `${i18n.t('fertilization.application_groups')}.xlsx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('fertilization/applicationgroups')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            table.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('farms/crops')
        .then((response) => {
          this.crops = response.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
<style>
.width-label {
  width: 500px !important;
}
</style>
